module.exports = __webpack_public_path__ + "img/logo-huahe.6cce7125.png";